/** Build a client route to the teacher profile detail page. */
export function teacherDetailPath(id, regNumber) {
  const numId = id != null && String(id).trim() !== "" ? String(id).trim() : "";
  const reg = regNumber != null && String(regNumber).trim() !== "" ? String(regNumber).trim() : "";
  if (numId) return `/enseignant/${encodeURIComponent(numId)}`;
  if (reg) return `/enseignant/detail?regNumber=${encodeURIComponent(reg)}`;
  return null;
}

/** HTML href for map popups (Leaflet). */
export function teacherDetailHref(row) {
  const id = row?.id ?? row?.Id ?? row?.teacherId ?? row?.TeacherId;
  const reg = row?.regNumber ?? row?.RegNumber ?? "";
  return teacherDetailPath(id, reg) || "/enseignantes";
}
